import { Badge } from "@/components/ui/badge";
import { PRIORITY, PRIORITY_STYLE, STATUS, STATUS_STYLE } from "@/lib/api";
import { Loader2 } from "lucide-react";

export function StatusBadge({ value }) {
  return (
    <Badge data-testid={`status-badge-${value}`} className={`${STATUS_STYLE[value] || ""} border-0 text-[11px] font-medium hover:bg-transparent`}>
      {STATUS[value] || value}
    </Badge>
  );
}

export function PriorityBadge({ value }) {
  return (
    <Badge data-testid={`priority-badge-${value}`} className={`${PRIORITY_STYLE[value] || ""} border-0 text-[11px] font-medium hover:bg-transparent`}>
      {PRIORITY[value] || value}
    </Badge>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl tracking-tight font-semibold text-zinc-100" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-400 mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function Spinner() {
  return (
    <div className="flex items-center justify-center py-16" data-testid="loading-spinner">
      <Loader2 className="h-6 w-6 animate-spin text-indigo-400" />
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      <div className="h-12 w-12 rounded-full bg-zinc-800 flex items-center justify-center mb-4">
        <Icon className="h-5 w-5 text-zinc-400" />
      </div>
      <p className="text-sm font-medium text-zinc-200">{title}</p>
      {subtitle && <p className="text-xs text-zinc-500 mt-1 max-w-xs">{subtitle}</p>}
    </div>
  );
}
